/**
 * Our Process page — outlines the bridal beauty journey from enquiry to wedding day.
 * Renders the main process roadmap (ProcessSection) with Navbar and Footer.
 */
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ProcessSection from '../components/services/ProcessSection';

const Process = () => {
  return (
    <div id="process">
      <Navbar />
      {/* Six-step bridal process: enquiry → booking → consultation → design → artist → wedding day */}
      <ProcessSection />
      <Footer />
    </div>
  );
};

export default Process;


